export default function hasValidFile(files: Array<{ file: any, validUntilDate: Date | string, comment?: string }>) {
  const now = new Date().getTime();
  const validFile = files.find(f => {
    if (!f || !f.file || !f.validUntilDate) return false;
    const validUntilTime = new Date(f.validUntilDate).getTime();
    return validUntilTime > now;
  });
  return validFile ? validFile : files[files.length - 1]; // If no valid file, return the last file
}